import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import LogoOnlyLayout from "../components/dashboard/LogoOnlyLayout";
import Login from "../pages/login/LoginForm";
import ForgotPassword from "../pages/login/ForgotPassword";
import OtpScreen from "../pages/login/OtpScreen";
import ConfirmPassword from "../pages/login/ConfirmPassword";
import Home from "../pages/home/Home";
import Hospitality from "../pages/home/hospitality/Hospitality";
import DashboardLayout from "../components/layouts";
import Wareouse from "../pages/wareHouse/Wareouse";
import HealthCare from "../pages/healthCare/HealthCare";
import OfficeSource from "../pages/officeSource/OfficeSource";
import RetailSource from "../pages/retailSource/RetailSource";
import FoodSource from "../pages/foodSource/FoodSource";
import Partners from "../pages/partners/Partners";
import AffilationsPartners from "../pages/partners/AffilationsPartners";
import RecruitmentPartners from "../pages/partners/RecruitmentPartners";
import RecruitmentPartnerDetail from "../pages/partners/recruitmentPartners/RecruitmentPartnerDetail";
import AffilationsDetail from "../pages/partners/affilations/AffilationDetail";
import Profile from "../pages/profile/Profile";
import ConstructionSource from "../pages/contructionSource/ConstructionSource";
import InterView from "../pages/interview/nterView";
import Leader from "../pages/leadr/Leader";
import HR from "../pages/hr/Hr";
import JobDescription from "../pages/jobDescription/JobDescription";
import Temping from "../pages/temping/Temping";
import LiveJobFeeed from "../pages/libeJobFeed/LiveJobFeed";
import PartnerDetail from "../pages/partners/PartnerDetail";
import WareHousePartners from "../pages/wareHouse/WareHousePartners";
import WareHouseAffiliation from "../pages/wareHouse/warehouseAffialations/WareHouseAffialationPartners";
import WareHouseRecruitment from "../pages/wareHouse/warehouseRecruitment/WareHouseRecruitmentPartners";
import WareHousePartnerDetail from "../pages/wareHouse/WareHousePartnerDetail";
import WareHouseRecruitmentDetail from "../pages/wareHouse/warehouseRecruitment/WareHouseRecruitmentDetail";
import HealthCarePartners from "../pages/healthCare/HealthCarePartners";
import HealthCareAffiliationPartners from "../pages/healthCare/healthcareAffilations/HealthCareAffiliationPartners";
import HealthCareAffiliationDetail from "../pages/healthCare/healthcareAffilations/AffiliationDetail";
import RecruitmentHealthCare from "../pages/healthCare/recruitment/RecruitmentHealthcarePartners";
import HealthCareRecruitmentDetail from "../pages/healthCare/recruitment/HealtCareRecruitmentDetail";
import HealthCarePartnerDetail from "../pages/healthCare/HealthCraepartnerDetail";
import OfficePartners from "../pages/officeSource/partners/Office[Partners";
import OfficePartnerDetail from "../pages/officeSource/partners/OfficePartnersDetail";
import OfficeAFfiliationPartners from "../pages/officeSource/affiliation/OfficeAffiliationPartners";
import OfficeRecruitmentPartners from "../pages/officeSource/recruitment/OfficeRecruitmentPartners";
import OfficeAffiliationDetail from "../pages/officeSource/affiliation/OfficeAffiliationDetail";
import OfficeRecruitmentDetail from "../pages/officeSource/recruitment/OfficeRecruitmentDetail";
import WareHouseInterView from "../pages/wareHouse/interview/WareHouseInterView";
import RetailSourcePartners from "../pages/retailSource/RetailSourcePartners";
import RetailSourcePartnersDetail from "../pages/retailSource/RetailSourcePartnersDetail";
import RetailAffiliationPartners from "../pages/retailSource/retailAffiliation/RetailAffiliation";
import ReatailAffiliationdetail from "../pages/retailSource/retailAffiliation/RetailAffiliationDetail";
import RetailRecruitmentPartners from "../pages/retailSource/recruitment/RetailRecruitmentPartners";
import ReatailRecruitmentdetail from "../pages/retailSource/recruitment/RetailRecruitmentPartnerDetail";
import FoodSourcePartners from "../pages/foodSource/FoodSourcePartners";
import FoodSourcePartnersDetails from "../pages/foodSource/FoodSourcePartnerDetail";
import FoodSourceAffiliation from "../pages/foodSource/affiliationPartners/AffiliationPartnersFood";
import FoodSourceRecruitment from "../pages/foodSource/recruitment/RecruitmentPartnerFood";
import WareHouseIndustry from "../pages/leaderIntheIndustry/WareHouseIndustry";
import WareHouseHr from "../pages/hrPages/WareHouseHr";
import WareHouseJobDescription from "../pages/jobDescriptionPages/WareHouseJobDesscription";
import WareHouseLiveJobFeed from "../pages/liveJobFeeds/WareHouseLiveJobFeeds";
import WareHouseTemping from "../pages/tempingPages/WareHouseTemping";
import HealthCraeInterview from "../pages/interViewPages/HealthCareInterview";
import HealthCareHr from "../pages/hrPages/HealthcareHr";
import HealthCareJobDescription from "../pages/jobDescriptionPages/HealthCraeJobDescription";
import HealthCareLiveJobs from "../pages/liveJobFeeds/HeallthCraeLiveJobs";
import HealthCraeTemping from "../pages/tempingPages/HealthcareTeming";
import HealthCreLeaders from "../pages/leadersInIndustry/HealthCraeLeaders";
import FoodSourceInterview from "../pages/interViewPages/FoodSourceInterView";
import FoodLeaders from "../pages/leadersInIndustry/FoodSourceLeaders";
import FoodHr from "../pages/hrPages/FoodSourceHr";
import FodJobDescription from "../pages/jobDescriptionPages/FoodJobDescription";
import FoodLiveJob from "../pages/liveJobFeeds/FoodLiveJobFeeds";
import FoodTemping from "../pages/tempingPages/FoodTemping";
import OfficeInterView from "../pages/interViewPages/OfficeInterVie";
import OfficeHr from "../pages/hrPages/OfficeHr";
import OfficeJobs from "../pages/jobDescription/OfficeJobDescription";
import OfficeLiveJbs from "../pages/liveJobFeeds/OfficeLiveJobs";
import OfficeTemping from "../pages/temping/OfficeTemping";
import RetailInterView from "../pages/interview/RetailInterView";
import RetailLeader from "../pages/leadersInIndustry/RetailLeader";
import RetailHr from "../pages/hrPages/RetailHr";
import RetailJobs from "../pages/jobDescription/RetailJobs";
import RetailLiveJobs from "../pages/libeJobFeed/RetailLiveJobs";
import RetailTemping from "../pages/temping/RetailTemping";
import ContructionPartners from "../pages/contructionSource/partners/ContructionPartners";
import ContructionInterView from "../pages/interview/ContructionnterView";
import ContructionLeader from "../pages/leadersInIndustry/ContructionLeader";
import ConstructionHr from "../pages/hrPages/ContructionHr";
import ConstructionJobs from "../pages/jobDescription/ConstructionJobescription";
import ConstructionLiveJobFeed from "../pages/libeJobFeed/ContructionLiveJobFeed";
import ConTructionTemping from "../pages/temping/ContructionTemping";
import FitOurInterView from "../pages/interview/FitOurInterView";
import FitOurSorceLeader from "../pages/jobDescriptionPages/HealthCraeJobDescription";
import FitOurHr from "../pages/hrPages/FitOurHr";
// import fitOurJobs from "../pages/jobDescription/fitOurJobs";
// import fitOurLivejobFeed from "../pages/libeJobFeed/fitOurLivejob";
// import fitOurTemping from "../pages/temping/fitOurTemping";
import FitOutSource from "../pages/fitOutSource/FitOutSource";
import FitOutPartners from "../pages/fitOutSource/partners/FitOutPartners";
import FitOutAffiliation from "../pages/fitOutSource/partners/FitutAffiliationPartners";
import FitOutRecruitmentPartner from "../pages/fitOutSource/partners/FitOutRecruitmentPARTNER.jsx";
import Registerform from "../pages/login/RegisterForm.jsx";
import HospitalityTrainingSource from "../pages/traingSource/HospitalityTrainingSource.jsx";
import HospitalityMindsetSource from "../pages/mindsetSource/HospitalityMindsetSource.jsx";
import InterViewDetail from "../pages/interview/InterViewDetail.jsx";
import InterviewBlogList from "../pages/interview/InterViewListBlog.jsx";
import WareHouseBlogList from "../pages/wareHouse/interview/WareHouseInterViewBlogList.jsx";
import WareHouseInterViewDetail from "../pages/wareHouse/interview/WareHouseInterViewDetail.jsx";
import Interview from "../pages/wareHouse/interview/healthcare/HealthCrareinterView.jsx";
import HealthCareBlogList from "../pages/wareHouse/interview/healthcare/HealthCareInterViewBloglist.jsx";
import HealthCareInterViewDetail from "../pages/wareHouse/interview/healthcare/HealthCraeInterViewDetail.jsx";
import OfficeInterview from "../pages/interViewPages/OfficeInterVie";
import OfficeeBlogList from "../pages/interview/officeInterView/OfficeItnerViewBlogs.jsx";
import OfficeInterViewDetail from "../pages/interview/officeInterView/OfficeblogDetail.jsx";
import RetailInterview from "../pages/interview/RetailInterView";
import RetailBlogList from "../pages/interview/retailInterView/RetailBlogs.jsx";
import RetailInterViewDetail from "../pages/interview/retailInterView/RetailInterViewDetail.jsx";
import FoodSourceBlogList from "../pages/wareHouse/interview/foodsourceInterView/FoodSourceBlogList.jsx";
import FoodSourceInterViewDetail from "../pages/wareHouse/interview/foodsourceInterView/FoodSourceInterViewDetail.jsx";
import ConstructionInterview from "../pages/interview/ContructionnterView";
import ConstructionBlogList from "../pages/interview/constructionInterView/ConstructionBlogList.jsx";
import ConstructionInterViewDetail from "../pages/interview/constructionInterView/ConstructionInterViewDetail.jsx";
import FitOutInterview from "../pages/interview/FitOurInterView";
import FitOutBlogList from "../pages/interview/fitOutInterView/FitOutInterviewBlogs.jsx";
import FitOutBlogsDetail from "../pages/interview/fitOutInterView/FitOutBlogsDetail.jsx";
import WareHouseTrainingSource from "../pages/traingSource/WareHouseTrainingSorce.jsx";
import WareHouseMindSet from "../pages/mindsetSource/WareHouseMindSet.jsx";
import HealthCareTrainingSource from "../pages/traingSource/ealthCareTrainingSource.jsx";
import HealthcareMndset from "../pages/mindsetSource/HealthCareMindSet.jsx";
import OfficeTrainingSource from "../pages/traingSource/OfficeTrainingSource.jsx";
import OfficeSourceMindSet from "../pages/mindsetSource/OfficeSourceNindSet.jsx";
import RetailTrainin from "../pages/traingSource/RetailTrainingsource.jsx";
import RetailTraining from "../pages/traingSource/RetailTrainingsource.jsx";
import RetailMindSet from "../pages/mindsetSource/ReatailMindSet.jsx";
import FoodTrainingSource from "../pages/traingSource/foodTrainingSource.jsx";
import FoodMindSetSource from "../pages/mindsetSource/FoodMindsetSource.jsx";
import ConstructionTrainingSource from "../pages/traingSource/ConstructionTrainingSorce.jsx";
import ConstructionMindSet from "../pages/mindsetSource/ConstructionMindSet.jsx";
import FitOutTraining from "../pages/traingSource/FitOutTraining.jsx";
import FitOutMindSet from "../pages/mindsetSource/FitOutMindSet.jsx";
import WareHouseaffiliationDetail from "../pages/partners/affilations/WareHouseAffiliationDetail.jsx";
import ConstructionPartnerDetail from "../pages/contructionSource/partners/ConstructionPartnerDetail.jsx";
import ConstructionSourceAffiliation from "../pages/contructionSource/partners/ConstructionAffiliationPartners.jsx";
import ConstructionAffiliationPartnerDetail from "../pages/contructionSource/partners/ConstructionAffilaitionDetail.jsx";
import ConstructionSourceRecruitment from "../pages/contructionSource/partners/recruitmentPartners/ConstructionRecruitmentPartners.jsx";
import ConstructionRecruitmentPartnerDetail from "../pages/contructionSource/partners/recruitmentPartners/ConstructionRecruitmentDetail.jsx";
import FitOutAffiliationDetail from "../pages/fitOutSource/partners/FitOutAffilaitionDetail.jsx";
import FitOutRecruitmentDetail from "../pages/fitOutSource/partners/FitOutRecruitmentDetail.jsx";
import FitOutPartnerDetail from "../pages/fitOutSource/partners/FitOutPartnerDetai;.jsx";
import FodSourceAffiliationDetail from "../pages/foodSource/affiliationPartners/FoodSourceAffiliationDetail.jsx";
import RecruitemnetFoodDetail from "../pages/foodSource/recruitment/FoodSourceRecruitmentDetail.jsx";
import PodcasthospitalityListing from "../pages/industryLeadersPodcasts/PodcastHospitalityList.jsx";
import IndustryNewshospitalityListing from "../pages/industryNewsLists/HospitalityOndustryNewsListing.jsx";
import PodcastWareHouseListing from "../pages/industryLeadersPodcasts/WareHousePodcasts.jsx";
import IndustryNewsWareHouseListing from "../pages/industryNewsLists/WareHouseIndustryNews.jsx";
import PodcastHealthCareListing from "../pages/industryLeadersPodcasts/HealthCarePodcastListing.jsx";
import IndustryListingHealthCare from "../pages/industryNewsLists/IndustryNewsHealthCareListing.jsx";
import OfficeLeaders from "../pages/interViewPages/OfficeInterVie";
import OfficeLeader from "../pages/leadersInIndustry/OfficeLeaders.jsx";
import OfficePodcastList from "../pages/industryLeadersPodcasts/OfficePodcastList.jsx";
import OfficeIndustryList from "../pages/industryLeadersPodcasts/OfficeIndustryList.jsx";
import RetailPodcastList from "../pages/industryLeadersPodcasts/RetailPodcastsListing.jsx";
import RetailIndustryList from "../pages/industryLeadersPodcasts/RetailIndustryList.jsx";
import FoodPodcastList from "../pages/industryLeadersPodcasts/FoodPodcastList.jsx";
import FodIndustryList from "../pages/industryLeadersPodcasts/FoodIndustryList.jsx";
import ConstructionPodcastList from "../pages/industryLeadersPodcasts/ConstructionPodcastList.jsx";
import ConstructionIndustryList from "../pages/industryLeadersPodcasts/ConstructionIndustryList.jsx";
import FitOutPodcastList from "../pages/industryLeadersPodcasts/FitOutSorcePodcast.jsx";
import FitOutIndustryList from "../pages/industryLeadersPodcasts/FitOutIndustryList.jsx";
import HospitalityPodcastDetail from "../pages/podcastdetailPages/HospitalityPodcastDetail.jsx";
import HospitalityIndustryDetail from "../pages/industryNewsDetailPages/HospitalityIndustryNewsDetail.jsx";
import FavouriteJobs from "../components/jobs/FavouriteJobs.jsx";
import HrBlogList from "../pages/hr/HrBlogList.jsx";
import HrBlogDetail from "../pages/hr/HrBlogDetail.jsx";
import WareHouseBloglist from "../pages/hrPages/WareHOuseHrBlogList.jsx";
import HealthCareBlogListNew from "../pages/hrPages/HealthcareHrBlogList.jsx";
import OfficeHrBlogList from "../pages/hrPages/OfficeHrBlogList.jsx";
import RetailSourceBlogHr from "../pages/hrPages/RetailHrBlogList.jsx";
import FoodSourceHrBlog from "../pages/hr/FoodSourceHrBlog.jsx";
import FitOutHrBlog from "../pages/hr/FitOutHrBlogList.jsx";
import JobDetailPage from "../pages/libeJobFeed/LiveJobdetail.jsx";
import FitOutLivejobs from "../pages/libeJobFeed/FitOutLivejobs";
import HrDetail from "../pages/hr/HRdetail.jsx";
import HRblogDetailInside from "../pages/hr/HrInsideBlogDetail.jsx";
import TrainingSourceBlogs from "../pages/traingSource/HospitalityBlogsListTraining.jsx";
import TraingBlogDetail from "../pages/traingSource/trainingssourceblogDetail.jsx";
import PartnersCategory from "../pages/partners/PartnersCategory.jsx";
import BlogDetail from "../pages/traingSource/BlogDetail.jsx";
import MindsetHospitalityListAll from "../pages/mindsetSource/HospitalutyBlogListingMindset.jsx";
import MindsetBlogDetail from "../pages/mindsetSource/BlogDetailNewMindset.jsx";
import JDListall from "../pages/jobDescription/JDListall.jsx";
import JDDetailAll from "../pages/jobDescription/JDdetailall.jsx";
import TempingListall from "../pages/temping/TempingListall.jsx";
import TempingDetailall from "../pages/temping/TempingDetailall.jsx";
import PersonalJobs from "../pages/libeJobFeed/PersonalJobs.jsx";
import PostJobDetail from "../components/popUp/PostJobDetail.jsx";
import PersonalJobDetail from "../pages/libeJobFeed/PersonalJobDetail.jsx";
import Candidtes from "../pages/libeJobFeed/CandidatesForJob.jsx";
import Candidates from "../pages/libeJobFeed/CandidatesForJob.jsx";
import PersonalPageCandidates from "../pages/libeJobFeed/PersonalJobsCandidates.jsx";
import FavJobDetail from "../pages/libeJobFeed/FavJobDetail.jsx";
import FavJobsCandidates from "../pages/libeJobFeed/FavJobCandidates.jsx";
import PostJobDetail2 from "../pages/post/PostJobDetail.jsx";
import Candidates2 from "../pages/post/CandiateJobsOutside.jsx";
import { useIds } from "../hook/AdminContext.js";
import { enqueueSnackbar } from "notistack";
import RecordNotFound from "../components/recordNotFound/RecordNotFound.js";
import RecordNotFound2 from "../components/recordNotFound/SataNitFound.js";
import IndustryPartners from "../pages/partners/IndustryPartners.jsx";
import PartnerDetailIndustry from "../pages/partners/PrtnerDetailIndustry.jsx";
import PartnersClients from "../pages/partners/PartnersClients.jsx";
import PartnerDetailClients from "../pages/partners/PARTNERcLIENTSdETAIL.jsx";
import Suppliers from "../pages/partners/Suooliers.jsx";
import SupplierDetail from "../pages/partners/SuppliersDetail.jsx";
import InterviewBlogDetailPage from "../pages/hr/InterViewBlogDetailpage.jsx";
import TrainingBlogDetailPage from "../pages/hr/TrainingBlogDetailPage.jsx";
import MindsetBlogDetailPage from "../pages/hr/MindsetTrainingBlogdetailPgae.jsx";
import JdDetailPageBlog from "../pages/hr/JdDetailPageBlog.jsx";
import TempingBlogDetailPage from "../pages/hr/TempinBlogDetailPage.jsx";
import AppliedJobs from "../pages/libeJobFeed/AppliedJobs.jsx";
import PaymentRequests from "../pages/paymentsRequests/PaymentRequest.jsx";
import PendingRequests from "../pages/paymentsRequests/PendingRequests.js";
import PendingRequestsPayment from "../pages/paymentsRequests/PendingRequestsDetail.js";
import PaymentRequestsDetails from "../pages/paymentsRequests/PaymentRequestDetails.jsx";

// Utility function to check access for sources and features
function checkAccess({ pathname, userInfo }) {
  // Map of path substrings to required source titles
  const sourceAccessMap = [
    { key: "hospitality", title: "Hospitality" },
    { key: "warehouse", title: "Warehouse & Logistics" },
    { key: "healthcare", title: "Healthcare Source" },
    { key: "office-source", title: "Office Source" },
    { key: "retail-source", title: "Retail Source" },
    { key: "food-source", title: "Food Source" },
    { key: "construction-source", title: "Construction Source" },
    { key: "fitOut-source", title: "Fit out Source" },
    { key: "fit-out-source", title: "Fit out Source" },
  ];
  // Map of path substrings to required feature titles (for type 1)
  const featureAccessMap = [
    { key: "interview", title: "Interview" },
    { key: "clients", title: "Clients" },
    { key: "leader-in-the-industry", title: "Leaders In The Industry" },
    { key: "hr", title: "HR" },
    { key: "training-source", title: "Training Source" },
    { key: "industry-partners", title: "Industry Partners" },

    { key: "partners", title: "Agency Partners" },
    { key: "suppliers", title: "Industry Suppliers" },
    { key: "temping", title: "Temping" },
    { key: "live-job-feed", title: "Live Job Feed" },
    { key: "job-description", title: "Job Description" },
    { key: "mindset-source", title: "Mindset Source" },
  ];
  console.log(userInfo, "userInfouserInfouserInfouserInfo");
  // Check feature access for type 1
  if (userInfo?.type === 1) {
    for (const { key, title } of featureAccessMap) {
      if (
        pathname.includes(key) &&
        !userInfo?.feature?.some((feature) => feature?.title === title)
      ) {
        console.log(title, "titletitletitletitletitle");
        return <RecordNotFound2 title={`You have no access to ${title}`} />;
      }
    }
  }

  // Check source access for type 1 and 2
  if (userInfo?.type === 2 || userInfo?.type === 1) {
    for (const { key, title } of sourceAccessMap) {
      if (
        pathname.includes(key) &&
        !userInfo?.source?.some((source) => source.title === title)
      ) {
        return <RecordNotFound2 title={`You have no access to ${title}`} />;
      }
    }
  }
  return null;
}

const Authentication = () => {
  if (localStorage.getItem("token")) {
    return <Navigate to="/home"> </Navigate>;
  } else {
    return <Navigate to="/login"> </Navigate>;
  }
};

export default function AppRoutes() {
  const { userInfo } = useIds();
  const location = useLocation();
  const [hasError, setHasError] = useState(false);
  const NoAccessPage = () => <div>You do not have access to this page.</div>;

  // Use the new utility function for access checks
  const accessResult = checkAccess({ pathname: location.pathname, userInfo });
  if (accessResult) return accessResult;

  return (
    <Routes>
      {/* Dashboard routes */}
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<Authentication />} />
        {/* This sets "Home" as the default route */}
        <Route path="home" element={<Home />} />
        <Route path="hospitality" element={<Home />} />
        <Route
          path="hospitality/training-source"
          element={<HospitalityTrainingSource />}
        />
        <Route
          path="hospitality/training-source/blog-detail/:id"
          element={<TrainingBlogDetailPage />}
        />
        <Route
          path="hospitality/job-description/blog-detail/:id"
          element={<JdDetailPageBlog />}
        />
        <Route
          path="warehouse/job-description/blog-detail/:id"
          element={<JdDetailPageBlog />}
        />
        <Route
          path="healthcare/job-description/blog-detail/:id"
          element={<JdDetailPageBlog />}
        />
        <Route
          path="retail-source/job-description/blog-detail/:id"
          element={<JdDetailPageBlog />}
        />
        <Route
          path="office-source/job-description/blog-detail/:id"
          element={<JdDetailPageBlog />}
        />
        <Route
          path="food-source/job-description/blog-detail/:id"
          element={<JdDetailPageBlog />}
        />
        <Route
          path="construction-source/job-description/blog-detail/:id"
          element={<JdDetailPageBlog />}
        />
        <Route
          path="fit-out-source/job-description/blog-detail/:id"
          element={<JdDetailPageBlog />}
        />
        <Route
          path="warehouse/training-source/blog-detail/:id"
          element={<TrainingBlogDetailPage />}
        />
        <Route
          path="healthcare/training-source/blog-detail/:id"
          element={<TrainingBlogDetailPage />}
        />
        <Route
          path="fppd-source/training-source/blog-detail/:id"
          element={<TrainingBlogDetailPage />}
        />
        <Route
          path="retail-source/training-source/blog-detail/:id"
          element={<TrainingBlogDetailPage />}
        />
        <Route
          path="construction-source/training-source/blog-detail/:id"
          element={<TrainingBlogDetailPage />}
        />
        <Route
          path="fit-out-source/training-source/blog-detail/:id"
          element={<TrainingBlogDetailPage />}
        />
        <Route
          path="retail-source/training-source/blog-detail/:id"
          element={<TrainingBlogDetailPage />}
        />
        <Route
          path="warehouse/training-source"
          element={<HospitalityTrainingSource />}
        />
        <Route
          path="retail-source/training-source"
          element={<HospitalityTrainingSource />}
        />
        <Route
          path="retail-source/training-source/blog-list/:id"
          element={<TrainingSourceBlogs />}
        />
        <Route
          path="hospitality/temping/blog-detail/:id"
          element={<TempingBlogDetailPage />}
        />
        <Route
          path="warehouse/temping/blog-detail/:id"
          element={<TempingBlogDetailPage />}
        />
        <Route
          path="healthcare/temping/blog-detail/:id"
          element={<TempingBlogDetailPage />}
        />
        <Route
          path="food-source/temping/blog-detail/:id"
          element={<TempingBlogDetailPage />}
        />
        <Route
          path="retail-source/temping/blog-detail/:id"
          element={<TempingBlogDetailPage />}
        />
        <Route
          path="office-source/temping/blog-detail/:id"
          element={<TempingBlogDetailPage />}
        />
        <Route
          path="construction-source/temping/blog-detail/:id"
          element={<TempingBlogDetailPage />}
        />
        <Route
          path="fit-out-source/temping/blog-detail/:id"
          element={<TempingBlogDetailPage />}
        />
        <Route
          path="healthcares/training-source"
          element={<HospitalityTrainingSource />}
        />
        <Route
          path="food-source/training-source"
          element={<HospitalityTrainingSource />}
        />
        <Route
          path="office-source/training-source"
          element={<HospitalityTrainingSource />}
        />
        <Route
          path="fit-out-source/training-source"
          element={<HospitalityTrainingSource />}
        />
        <Route
          path="construction-source/training-source"
          element={<HospitalityTrainingSource />}
        />
        <Route
          path="construction-source/training-source/blog-list/:id"
          element={<TrainingSourceBlogs />}
        />
        <Route
          path="fit-out-source/training-source/blog-list/:id"
          element={<TrainingSourceBlogs />}
        />
        <Route
          path="fit-out-source/training-source/blog-list/:blog_id/blog-detail/:id"
          element={<BlogDetail />}
        />
        <Route
          path="hospitality/mindset-source/blog-list/:blog_id/blog-detail/:id"
          element={<MindsetBlogDetail />}
        />
        <Route
          path="healthcare/mindset-source/blog-list/:blog_id/blog-detail/:id"
          element={<MindsetBlogDetail />}
        />
        <Route
          path="office-source/mindset-source/blog-list/:blog_id/blog-detail/:id"
          element={<MindsetBlogDetail />}
        />
        <Route
          path="food-source/mindset-source/blog-list/:blog_id/blog-detail/:id"
          element={<MindsetBlogDetail />}
        />
        <Route
          path="construction-source/mindset-source/blog-list/:blog_id/blog-detail/:id"
          element={<MindsetBlogDetail />}
        />
        <Route
          path="fit-out-source/mindset-source/blog-list/:blog_id/blog-detail/:id"
          element={<MindsetBlogDetail />}
        />
        <Route
          path="retail-source/mindset-source/blog-list/:blog_id/blog-detail/:id"
          element={<MindsetBlogDetail />}
        />
        <Route
          path="warehouse/mindset-source/blog-list/:blog_id/blog-detail/:id"
          element={<MindsetBlogDetail />}
        />
        <Route
          path="construction-source/training-source/blog-list/:blog_id/blog-detail/:id"
          element={<BlogDetail />}
        />
        <Route
          path="office-source/training-source/blog-list/:blog_id/blog-detail/:id"
          element={<BlogDetail />}
        />
        <Route
          path="office-source/training-source/blog-list/:id"
          element={<TrainingSourceBlogs />}
        />
        <Route
          path="food-source/training-source/blog-list/:id"
          element={<TrainingSourceBlogs />}
        />
        <Route
          path="retail-source/training-source/blog-list/:blog_id/blog-detail/:id"
          element={<BlogDetail />}
        />
        <Route
          path="food-source/training-source/blog-list/:blog_id/blog-detail/:id"
          element={<BlogDetail />}
        />
        <Route
          path="hospitality/training-source/blog-list/:id"
          element={<TrainingSourceBlogs />}
        />
        <Route
          path="healthcare/training-source/blog-list/:id"
          element={<TrainingSourceBlogs />}
        />
        <Route
          path="warehouse/training-source/blog-list/:id"
          element={<TrainingSourceBlogs />}
        />
        <Route
          path="warehouse/training-source/blog-list/:id"
          element={<TrainingSourceBlogs />}
        />
        <Route
          path="hospitality/training-source/blog-list/:blog_id/blog-detail/:id"
          element={<BlogDetail />}
        />
        <Route
          path="healthcare/training-source/blog-list/:blog_id/blog-detail/:id"
          element={<BlogDetail />}
        />
        <Route
          path="warehouse/training-source/blog-list/:blog_id/blog-detail/:id"
          element={<BlogDetail />}
        />
        <Route
          path="warehouse/training-source"
          element={<WareHouseTrainingSource />}
        />
        <Route
          path="healthcare/training-source"
          element={<HospitalityTrainingSource />}
        />
        {/* <Route
          path="healthcare/training-source"
          element={<HealthCareTrainingSource />}
        /> */}
        <Route
          path="office-source/training-source"
          element={<OfficeTrainingSource />}
        />
        <Route
          path="construction-source/training-source"
          element={<ConstructionTrainingSource />}
        />
        <Route
          path="food-source/training-source"
          element={<FoodTrainingSource />}
        />
        <Route
          path="retail-source/training-source"
          element={<RetailTraining />}
        />
        <Route
          path="hospitality/mindset-source"
          element={<HospitalityMindsetSource />}
        />
        <Route
          path="retail-source/mindset-source"
          element={<HospitalityMindsetSource />}
        />
        <Route
          path="construction-source/mindset-source"
          element={<HospitalityMindsetSource />}
        />
        <Route
          path="fit-out-source/mindset-source"
          element={<HospitalityMindsetSource />}
        />
        <Route
          path="healthcare/mindset-source"
          element={<HospitalityMindsetSource />}
        />
        <Route
          path="warehouse/mindset-source"
          element={<HospitalityMindsetSource />}
        />
        <Route
          path="office-source/mindset-source"
          element={<HospitalityMindsetSource />}
        />
        <Route
          path="food-source/mindset-source"
          element={<HospitalityMindsetSource />}
        />
        {/* <Route
          path="warehouse/mindset-source/blog-list/:blog_id/blog-detail/:id"
          element={<BlogDetail />}
        /> */}
        <Route
          path="warehouse/mindset-source/blog-list/:id"
          element={<MindsetHospitalityListAll />}
        />
        <Route
          path="retail-source/mindset-source/blog-list/:id"
          element={<MindsetHospitalityListAll />}
        />
        <Route
          path="food-source/mindset-source/blog-list/:id"
          element={<MindsetHospitalityListAll />}
        />
        <Route
          path="construction-source/mindset-source/blog-list/:id"
          element={<MindsetHospitalityListAll />}
        />
        <Route
          path="fit-out-source/mindset-source/blog-list/:id"
          element={<MindsetHospitalityListAll />}
        />
        <Route
          path="office-source/mindset-source/blog-list/:id"
          element={<MindsetHospitalityListAll />}
        />
        <Route
          path="healthcare/mindset-source/blog-list/:id"
          element={<MindsetHospitalityListAll />}
        />
        <Route
          path="hospitality/mindset-source/blog-list/:id"
          element={<MindsetHospitalityListAll />}
        />
        <Route
          path="construction-source/mindset-source"
          element={<ConstructionMindSet />}
        />
        <Route
          path="fit-out-source/training-source"
          element={<FitOutTraining />}
        />
        <Route
          path="food-source/mindset-source"
          element={<FoodMindSetSource />}
        />
        <Route
          path="fit-out-source/mindset-source"
          element={<FitOutMindSet />}
        />
        <Route
          path="retail-source/mindset-source"
          element={<RetailMindSet />}
        />
        <Route
          path="office-source/mindset-source"
          element={<OfficeSourceMindSet />}
        />
        <Route path="warehouse/mindset-source" element={<WareHouseMindSet />} />
        <Route
          path="healthcare/mindset-source"
          element={<HealthcareMndset />}
        />
        <Route path="warehouse" element={<Home />} />
        <Route path="healthcare" element={<Home />} />
        <Route path="office-source" element={<Home />} />
        <Route path="retail-source" element={<Home />} />
        {/* <Route path="retail-source/interview" element={<RetailInterview />} /> */}
        {/* <Route path="retail-source/job-description" element={<RetailJobs />} /> */}
        {/* <Route path="retail-source/hr" element={<RetailHr />} /> */}
        {/* <Route path="retail-source/temping" element={<RetailTemping />} /> */}
        <Route
          path="retail-source/leader-in-industry"
          element={<RetailLeader />}
        />
        <Route path="construction-source" element={<Home />} />
        {/* <Route
          path="construction-source/temping"
          element={<ConTructionTemping />}
        /> */}
        {/* <Route
          path="construction-source/hr"
          element={<ConstructionLiveJobFeed />}
        /> */}
        {/* <Route
          path="construction-source/job-description"
          element={<ConstructionJobs />}
        /> */}
        <Route
          path="construction-source/leader-in-industry"
          element={<ContructionLeader />}
        />
        {/* <Route
          path="construction-source/partners"
          element={<ContructionPartners />}
        /> */}
        {/* <Route
          path="construction-source/partners/partner-detail/:id"
          element={<ConstructionPartnerDetail />}
        /> */}
        <Route path="food-source" element={<Home />} />
        <Route path="fit-out-source" element={<Home />} />
        {/* <Route path="fit-out-source/partners" element={<FitOutPartners />} /> */}
        <Route
          path="construction-source/partners/affilation-partners"
          element={<ConstructionSourceAffiliation />}
        />
        <Route
          path="construction-source/partners/recruitment-partners"
          element={<ConstructionSourceRecruitment />}
        />
        {/* <Route
          path="fit-out-source/partners/partner-detail/:id"
          element={<FitOutPartnerDetail />}
        /> */}
        <Route
          path="construction-source/partners/recruitment-partners/recruitment-detail/:id"
          element={<ConstructionRecruitmentPartnerDetail />}
        />
        <Route
          path="fit-out-source/partners/recruitment-partners/recruitment-detail/:id"
          element={<FitOutRecruitmentDetail />}
        />
        <Route
          path="construction-source/partners/affilation-partners/affilation-detail/:id"
          element={<ConstructionAffiliationPartnerDetail />}
        />
        <Route
          path="construction-source/partners/affilation-partners/affilation-detail/:id"
          element={<FodSourceAffiliationDetail />}
        />
        <Route
          path="food-source/partners/recruitment-partners/recruitment-detail/:id"
          element={<RecruitemnetFoodDetail />}
        />
        <Route
          path="food-source/partners/affilation-partners/affilation-detail/:id"
          element={<FitOutAffiliationDetail />}
        />
        <Route
          path="fit-out-source/partners/affilation-partners"
          element={<FitOutAffiliation />}
        />
        <Route
          path="fit-out-source/partners/affilation-partners/affilation-detail/:id"
          element={<FitOutAffiliationDetail />}
        />
        <Route
          path="fit-out-source/partners/recruitment-partners"
          element={<FitOutRecruitmentPartner />}
        />
        {/* <Route path="fit-out-source/interview" element={<FitOutInterview />} /> */}
        {/* <Route path="fit-out-source/hr" element={<FitOurHr />} /> */}
        {/* <Route path="fit-out-source/temping" element={<fitOurJobs />} /> */}
        {/* <Route
          path="fit-out-source/job-description"
          element={<fitOurTemping />}
        /> */}
        <Route
          path="fit-out-source/leader-in-industry"
          element={<FitOurSorceLeader />}
        />
        <Route
          path="/food-source/partners/affilation-partners"
          element={<FoodSourceAffiliation />}
        />
        <Route
          path="/food-source/partners/recruitment-partners"
          element={<FoodSourceRecruitment />}
        />
        {/* <Route
          path="retail-source/partners/partner-detail/:id"
          element={<RetailSourcePartnersDetail />}
        /> */}
        {/* <Route
          path="food-source/partners/partner-detail/:id"
          element={<FoodSourcePartnersDetails />}
        /> */}
        {/* <Route path="food-source/interview" element={<FoodSourceInterview />} /> */}
        {/* <Route path="food-source/hr" element={<FoodHr />} /> */}
        {/* <Route path="food-source/temping" element={<FoodTemping />} /> */}
        {/* <Route path="food-source/live-job-feed" element={<FoodLiveJob />} /> */}
        {/* <Route
          path="food-source/job-description"
          element={<FodJobDescription />}
        /> */}
        <Route
          path="food-source/leader-in-industry"
          element={<FoodLeaders />}
        />
        <Route path="hospitality/suppliers" element={<Suppliers />} />
        <Route path="warehouse/suppliers" element={<Suppliers />} />
        <Route path="healthcare/suppliers" element={<Suppliers />} />
        <Route path="office-source/suppliers" element={<Suppliers />} />
        <Route path="retail-source/suppliers" element={<Suppliers />} />
        <Route path="food-source/suppliers" element={<Suppliers />} />
        <Route path="construction-source/suppliers" element={<Suppliers />} />
        <Route path="fit-out-source/suppliers" element={<Suppliers />} />
        <Route
          path="hospitality/suppliers/partner-detail/:detail_id"
          element={<SupplierDetail />}
        />
        <Route
          path="warehouse/suppliers/partner-detail/:detail_id"
          element={<SupplierDetail />}
        />
        <Route
          path="healthcare/suppliers/partner-detail/:detail_id"
          element={<SupplierDetail />}
        />
        <Route
          path="office-source/suppliers/partner-detail/:detail_id"
          element={<SupplierDetail />}
        />
        <Route
          path="food-source/suppliers/partner-detail/:detail_id"
          element={<SupplierDetail />}
        />
        <Route
          path="retail-source/suppliers/partner-detail/:detail_id"
          element={<SupplierDetail />}
        />
        <Route
          path="construction-source/suppliers/partner-detail/:detail_id"
          element={<SupplierDetail />}
        />
        <Route
          path="fit-out-source/suppliers/partner-detail/:detail_id"
          element={<SupplierDetail />}
        />
        {/* ========================suppliers end==================== */}
        <Route path="hospitality/clients" element={<PartnersClients />} />
        <Route path="warehouse/clients" element={<PartnersClients />} />
        <Route path="healthcare/clients" element={<PartnersClients />} />
        <Route path="office-source/clients" element={<PartnersClients />} />
        <Route path="retail-source/clients" element={<PartnersClients />} />
        <Route path="food-source/clients" element={<PartnersClients />} />
        <Route path="fit-out-source/clients" element={<PartnersClients />} />
        <Route
          path="construction-source/clients"
          element={<PartnersClients />}
        />
        <Route
          path="hospitality/clients/partner-detail/:detail_id"
          element={<PartnerDetailClients />}
        />
        <Route
          path="warehouse/clients/partner-detail/:detail_id"
          element={<PartnerDetailClients />}
        />
        <Route
          path="healthcare/clients/partner-detail/:detail_id"
          element={<PartnerDetailClients />}
        />
        <Route
          path="food-source/clients/partner-detail/:detail_id"
          element={<PartnerDetailClients />}
        />
        <Route
          path="office-source/clients/partner-detail/:detail_id"
          element={<PartnerDetailClients />}
        />
        <Route
          path="retail-source/clients/partner-detail/:detail_id"
          element={<PartnerDetailClients />}
        />
        <Route
          path="construction-source/clients/partner-detail/:detail_id"
          element={<PartnerDetailClients />}
        />
        <Route
          path="fit-out-source/clients/partner-detail/:detail_id"
          element={<PartnerDetailClients />}
        />
        <Route path="hospitality/partners" element={<PartnersCategory />} />
        <Route path="warehouse/partners" element={<PartnersCategory />} />
        <Route path="healthcare/partners" element={<PartnersCategory />} />
        <Route path="office-source/partners" element={<PartnersCategory />} />
        <Route path="retail-source/partners" element={<PartnersCategory />} />
        <Route path="food-source/partners" element={<PartnersCategory />} />
        <Route
          path="construction-source/partners"
          element={<PartnersCategory />}
        />
        <Route path="fit-out-source/partners" element={<PartnersCategory />} />
        <Route
          path="hospitality/industry-partners"
          element={<IndustryPartners />}
        />
        <Route
          path="warehouse/industry-partners"
          element={<IndustryPartners />}
        />
        <Route
          path="healthcare/industry-partners"
          element={<IndustryPartners />}
        />
        <Route
          path="food-source/industry-partners"
          element={<IndustryPartners />}
        />
        <Route
          path="office-source/industry-partners"
          element={<IndustryPartners />}
        />
        <Route
          path="retail-source/industry-partners"
          element={<IndustryPartners />}
        />
        <Route
          path="construction-source/industry-partners"
          element={<IndustryPartners />}
        />
        <Route
          path="fit-out-source/industry-partners"
          element={<IndustryPartners />}
        />
        <Route
          path="hospitality/industry-partners/partner-detail/:detail_id"
          element={<PartnerDetailIndustry />}
        />
        <Route
          path="warehouse/industry-partners/partner-detail/:detail_id"
          element={<PartnerDetailIndustry />}
        />
        <Route
          path="hospitality/partners/:category_id"
          element={<PartnersCategory />}
        />
        <Route
          path="healthcare/industry-partners/partner-detail/:detail_id"
          element={<PartnerDetailIndustry />}
        />
        <Route
          path="office-source/industry-partners/partner-detail/:detail_id"
          element={<PartnerDetailIndustry />}
        />
        <Route
          path="retail-source/industry-partners/partner-detail/:detail_id"
          element={<PartnerDetailIndustry />}
        />
        <Route
          path="food-source/industry-partners/partner-detail/:detail_id"
          element={<PartnerDetailIndustry />}
        />
        <Route
          path="construction-source/industry-partners/partner-detail/:detail_id"
          element={<PartnerDetailIndustry />}
        />
        <Route
          path="fit-out-source/industry-partners/partner-detail/:detail_id"
          element={<PartnerDetailIndustry />}
        />
        <Route
          path="hospitality/partners/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="fit-out-source/partners/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="warehouse/partners/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="healthcare/partners/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="food-source/partners/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="construction-source/partners/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="office-source/partners/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="retail-source/partners/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="healthcare/partners/:category_id"
          element={<PartnersCategory />}
        />
        <Route
          path="healthcare/partners/:category_id/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="warehouse/partners/:category_id"
          element={<PartnersCategory />}
        />{" "}
        <Route
          path="warehouse/partners/:category_id/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="food-source/partners/:category_id"
          element={<PartnersCategory />}
        />{" "}
        <Route
          path="food-source/partners/:category_id/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="office-source/partners/:category_id"
          element={<PartnersCategory />}
        />
        <Route
          path="office-source/partners/:category_id/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="fit-out-source/partners/:category_id"
          element={<PartnersCategory />}
        />
        <Route
          path="fit-out-source/partners/:category_id/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="construction-source/partners/:category_id"
          element={<PartnersCategory />}
        />
        <Route
          path="construction-source/partners/:category_id/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        <Route
          path="retail-source/partners/:category_id"
          element={<PartnersCategory />}
        />
        <Route
          path="retail-source/partners/:category_id/partner-detail/:detail_id"
          element={<PartnerDetail />}
        />
        {/* <Route path="healthcare/partners" element={<HealthCarePartners />} /> */}
        {/* <Route path="warehouse/partners" element={<WareHousePartners />} /> */}
        {/* <Route path="office-source/partners" element={<OfficePartners />} /> */}
        {/* <Route path="food-source/partners" element={<FoodSourcePartners />} /> */}
        {/* <Route path="office-source/interview" element={<OfficeInterview />} /> */}
        {/* <Route path="office-source/job-description" element={<OfficeJobs />} /> */}
        {/* <Route path="office-source/hr" element={<OfficeHr />} /> */}
        {/* <Route path="office-source/live-job-feed" element={<OfficeLiveJbs />} /> */}
        {/* <Route path="office-source/temping" element={<OfficeTemping />} /> */}
        <Route
          path="office-source/leader-in-industry"
          element={<OfficeLeader />}
        />
        <Route
          path="office-source/partners/affilation-partners"
          element={<OfficeAFfiliationPartners />}
        />
        <Route
          path="office-source/partners/recruitment-partners"
          element={<OfficeRecruitmentPartners />}
        />
        <Route
          path="/office-source/partners/affilation-partners/affilation-detail/:id"
          element={<OfficeAffiliationDetail />}
        />
        <Route
          path="retail-source/partners/recruitment-partners"
          element={<RetailRecruitmentPartners />}
        />
        <Route
          path="retail-source/partners/affilation-partners"
          element={<RetailAffiliationPartners />}
        />
        <Route
          path="/office-source/partners/recruitment-partners/recruitment-detail/:id"
          element={<OfficeRecruitmentDetail />}
        />
        {/* <Route
          path="office-source/partners/partner-detail/:id"
          element={<OfficePartnerDetail />}
        /> */}
        <Route
          path="retail-source/partners/affilation-partners/partner-detail/:id"
          element={<ReatailAffiliationdetail />}
        />
        <Route
          path="retail-source/partners/recruitment-partners/partner-detail/:id"
          element={<ReatailRecruitmentdetail />}
        />
        <Route
          path="warehouse/partners/partner-detail/:id"
          element={<WareHousePartnerDetail />}
        />
        <Route
          path="warehouse/partners/affilation-partners"
          element={<WareHouseAffiliation />}
        />
        <Route
          path="healthcare/partners/partner-detail/:id"
          element={<HealthCarePartnerDetail />}
        />
        <Route
          path="healthcare/partners/affilation-partners"
          element={<HealthCareAffiliationPartners />}
        />
        <Route
          path="healthcare/partners/recruitment-partners"
          element={<RecruitmentHealthCare />}
        />
        <Route
          path="healthcare/partners/affilation-partners/affiliation-detail/:id"
          element={<HealthCareAffiliationDetail />}
        />
        <Route
          path="healthcare/partners/recruitment-partners/recruitment-detail/:id"
          element={<HealthCareRecruitmentDetail />}
        />
        {/* <Route path="healthcare/interview" element={<HealthCraeInterview />} /> */}
        {/* <Route path="healthcare/temping" element={<HealthCraeTemping />} /> */}
        <Route
          path="healthcare/leader-in-industry"
          element={<HealthCreLeaders />}
        />
        {/* <Route
          path="healthcare/job-description"
          element={<HealthCareJobDescription />}
        /> */}
        {/* <Route path="healthcare/hr" element={<HealthCareHr />} /> */}
        <Route
          path="warehouse/partners/recruitment-partners"
          element={<WareHouseRecruitment />}
        />
        <Route
          path="warehouse/partners/recruitment-partners/recruitment-detail/:id"
          element={<WareHouseRecruitmentDetail />}
        />
        <Route path="profile" element={<Profile />} />
        <Route
          path="hospitality/partners/affilation-partners"
          element={<AffilationsPartners />}
        />
        <Route
          path="hospitality/partners/partner-detail/:id"
          element={<PartnerDetail />}
        />
        <Route
          path="hospitality/partners/recruitment-partners"
          element={<RecruitmentPartners />}
        />
        <Route
          path="hospitality/partners/recruitment-partners/recruitment-detail/:id"
          element={<RecruitmentPartnerDetail />}
        />
        <Route path="hospitality/interView" element={<InterView />} />
        <Route path="warehouse/interView" element={<InterView />} />
        <Route path="healthcare/interView" element={<InterView />} />
        <Route path="office-source/interView" element={<InterView />} />
        <Route path="retail-source/interView" element={<InterView />} />
        <Route path="food-source/interView" element={<InterView />} />
        <Route path="construction-source/interview" element={<InterView />} />
        <Route path="fit-out-source/interview" element={<InterView />} />
        <Route
          path="hospitality/interview/interview-blog-list/:interview_id/interview-detail/:id"
          element={<InterViewDetail />}
        />
        <Route
          path="warehouse/interview/interview-blog-list/:interview_id/interview-detail/:id"
          element={<InterViewDetail />}
        />
        <Route
          path="healthcare/interview/interview-blog-list/:interview_id/interview-detail/:id"
          element={<InterViewDetail />}
        />
        <Route
          path="office-source/interview/interview-blog-list/:interview_id/interview-detail/:id"
          element={<InterViewDetail />}
        />
        <Route
          path="retail-source/interview/interview-blog-list/:interview_id/interview-detail/:id"
          element={<InterViewDetail />}
        />
        <Route
          path="food-source/interview/interview-blog-list/:interview_id/interview-detail/:id"
          element={<InterViewDetail />}
        />
        <Route
          path="construction-source/interview/interview-blog-list/:interview_id/interview-detail/:id"
          element={<InterViewDetail />}
        />
        <Route
          path="fit-out-source/interview/interview-blog-list/:interview_id/interview-detail/:id"
          element={<InterViewDetail />}
        />
        {/* <Route
          path="construction-source/interview/interview-blog-list/:interview_id"
          element={<ConstructionBlogList />}
        /> */}
        {/* <Route
          path="healthcare/interview/interview-blog-list/:interview_id"
          element={<HealthCareBlogList />}
        /> */}
        <Route
          path="office-source/interview/interview-blog-list/:interview_id"
          element={<InterviewBlogList />}
        />
        <Route
          path="retail-source/interview/interview-blog-list/:interview_id"
          element={<InterviewBlogList />}
        />
        <Route
          path="food-source/interview/interview-blog-list/:interview_id"
          element={<InterviewBlogList />}
        />
        <Route
          path="construction-source/interview/interview-blog-list/:interview_id"
          element={<InterviewBlogList />}
        />
        <Route
          path="fit-out-source/interview/interview-blog-list/:interview_id"
          element={<InterviewBlogList />}
        />
        <Route
          path="food-source/interview/interview-blog-list/:interview_id"
          element={<FoodSourceBlogList />}
        />
        <Route
          path="fit-out-source/interview/interview-blog-list/:interview_id"
          element={<FitOutBlogList />}
        />
        <Route
          path="retail-source/interview/interview-blog-list/:interview_id"
          element={<RetailBlogList />}
        />
        <Route
          path="office-source/interview/interview-blog-list/:interview_id"
          element={<OfficeeBlogList />}
        />
        <Route
          path="warehouse/interview/interview-blog-list/interview-detail/:id"
          element={<WareHouseInterViewDetail />}
        />
        <Route
          path="hospitality/interview/interview-blog-list/:interview_id"
          element={<InterviewBlogList />}
        />
        <Route
          path="warehouse/interview/interview-blog-list/:interview_id"
          element={<InterviewBlogList />}
        />
        <Route
          path="healthcare/interview/interview-blog-list/:interview_id"
          element={<InterviewBlogList />}
        />
        <Route
          path="warehouse/interview/interView-blog-list/:interview_id"
          element={<WareHouseBlogList />}
        />
        <Route
          path="retail-source/partners"
          element={<RetailSourcePartners />}
        />
        <Route path="warehouse/interView" element={<WareHouseInterView />} />
        {/* <Route path="warehouse/hr" element={<WareHouseHr />} /> */}
        {/* <Route path="warehouse/temping" element={<WareHouseTemping />} /> */}
        {/* <Route
          path="warehouse/live-job-feed"
          element={<WareHouseLiveJobFeed />}
        /> */}
        {/* <Route
          path="warehouse/job-description"
          element={<WareHouseJobDescription />}
        /> */}
        <Route
          path="warehouse/leaders-in-the-industry"
          element={<WareHouseIndustry />}
        />
        <Route
          path="office-source/leader-in-industry/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="fit-out-source/leader-in-industry/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="construction-source/leader-in-industry/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="healthcare/leader-in-industry/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="retail-source/leader-in-industry/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="hospitality/leader-in-the-industry/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="food-source/leader-in-industry/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="warehouse/leaders-in-the-industry/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="office-source/leader-in-industry/podcast-listing/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="fit-out-source/leader-in-industry/podcast-listing/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="construction-source/leader-in-industry/podcast-listing/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="food-source/leader-in-industry/podcast-listing/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="retail-source/leader-in-industry/podcast-listing/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="warehouse/leaders-in-the-industry/podcast-listing/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="healthcare/leader-in-industry/podcast-listing/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="hospitality/leader-in-the-industry/podcast-listing/podcast-detail"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="healthcare/leader-in-industry/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="construction-source/leader-in-industry/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="fit-out-source/leader-in-industry/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="retail-source/leader-in-industry/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="construction-source/leader-in-industry/industry-news-listing/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route path="favourite-jobs" element={<FavouriteJobs />} />
        <Route path="favourite-jobs/applied-jobs" element={<AppliedJobs />} />
        <Route path="warehouse/favourite-jobs" element={<FavouriteJobs />} />
        <Route path="favourite-jobs/detail/:id" element={<FavJobDetail />} />
        <Route
          path="favourite-jobs/candidates/:id"
          element={<FavJobsCandidates />}
        />
        {/* <Route
          path="/:category/favourite-jobs/job-detail"
          element={<JobDetailPage />}
        /> */}
        <Route
          path="fit-out-source/leader-in-industry/industry-news-listing/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="retail-source/leader-in-industry/industry-news-listing/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="food-source/leader-in-industry/industry-news-listing/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="office-source/leader-in-industry/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="healthcare/leader-in-industry/industry-news-listing/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="office-source/leader-in-industry/industry-news-listing/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="hospitality/leader-in-the-industry/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="food-source/leader-in-industry/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="warehouse/leaders-in-the-industry/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="warehouse/leaders-in-the-industry/industry-news-listing/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="hospitality/leader-in-the-industry/industry-news-listing/industry-news-detail"
          element={<HospitalityIndustryDetail />}
        />
        <Route
          path="hospitality/leader-in-the-industry/podcast-listing"
          element={<PodcasthospitalityListing />}
        />
        <Route
          path="office-source/leader-in-industry/podcast-listing"
          element={<OfficePodcastList />}
        />
        <Route
          path="fit-out-source/leader-in-industry/podcast-listing"
          element={<FitOutPodcastList />}
        />
        <Route
          path="construction-source/leader-in-industry/podcast-listing"
          element={<ConstructionPodcastList />}
        />
        <Route
          path="food-source/leader-in-industry/podcast-listing"
          element={<FoodPodcastList />}
        />
        <Route
          path="retail-source/leader-in-industry/podcast-listing"
          element={<RetailPodcastList />}
        />
        <Route
          path="retail-source/leader-in-industry/podcast-listing"
          element={<OfficePodcastList />}
        />
        <Route
          path="healthcare/leader-in-industry/podcast-listing"
          element={<PodcastHealthCareListing />}
        />
        <Route path="hospitality/leader-in-the-industry" element={<Leader />} />
        <Route
          path="hospitality/leader-in-the-industry/:type/main-detail/:id"
          element={<HospitalityPodcastDetail main_tye={true} />}
        />
        <Route
          path="hospitality/leader-in-the-industry/podcast-listing/:type"
          element={<PodcastWareHouseListing />}
        />{" "}
        <Route
          path="hospitality/leader-in-the-industry/:type/detail/:id"
          element={<HospitalityPodcastDetail />}
        />
        <Route path="warehouse/leader-in-the-industry" element={<Leader />} />
        <Route
          path="warehouse/leader-in-the-industry/:type/main-detail/:id"
          element={<HospitalityPodcastDetail main_tye={true} />}
        />
        <Route
          path="warehouse/leader-in-the-industry/podcast-listing/:type"
          element={<PodcastWareHouseListing />}
        />{" "}
        <Route
          path="warehouse/leader-in-the-industry/:type/detail/:id"
          element={<HospitalityPodcastDetail />}
        />
        <Route path="healthcare/leader-in-the-industry" element={<Leader />} />
        <Route
          path="healthcare/leader-in-the-industry/:type/main-detail/:id"
          element={<HospitalityPodcastDetail main_tye={true} />}
        />
        <Route
          path="healthcare/leader-in-the-industry/podcast-listing/:type"
          element={<PodcastWareHouseListing />}
        />{" "}
        <Route
          path="healthcare/leader-in-the-industry/:type/detail/:id"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="office-source/leader-in-the-industry"
          element={<Leader />}
        />
        <Route
          path="office-source/leader-in-the-industry/:type/main-detail/:id"
          element={<HospitalityPodcastDetail main_tye={true} />}
        />
        <Route
          path="office-source/leader-in-the-industry/podcast-listing/:type"
          element={<PodcastWareHouseListing />}
        />{" "}
        <Route
          path="office-source/leader-in-the-industry/:type/detail/:id"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="retail-source/leader-in-the-industry"
          element={<Leader />}
        />
        <Route
          path="retail-source/leader-in-the-industry/:type/main-detail/:id"
          element={<HospitalityPodcastDetail main_tye={true} />}
        />
        <Route
          path="retail-source/leader-in-the-industry/podcast-listing/:type"
          element={<PodcastWareHouseListing />}
        />{" "}
        <Route
          path="retail-source/leader-in-the-industry/:type/detail/:id"
          element={<HospitalityPodcastDetail />}
        />
        <Route path="food-source/leader-in-the-industry" element={<Leader />} />
        <Route
          path="food-source/leader-in-the-industry/:type/main-detail/:id"
          element={<HospitalityPodcastDetail main_tye={true} />}
        />
        <Route
          path="food-source/leader-in-the-industry/podcast-listing/:type"
          element={<PodcastWareHouseListing />}
        />{" "}
        <Route
          path="food-source/leader-in-the-industry/:type/detail/:id"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="construction-source/leader-in-the-industry"
          element={<Leader />}
        />
        <Route
          path="construction-source/leader-in-the-industry/:type/main-detail/:id"
          element={<HospitalityPodcastDetail main_tye={true} />}
        />
        <Route
          path="construction-source/leader-in-the-industry/podcast-listing/:type"
          element={<PodcastWareHouseListing />}
        />{" "}
        <Route
          path="construction-source/leader-in-the-industry/:type/detail/:id"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="fit-out-source/leader-in-the-industry"
          element={<Leader />}
        />
        <Route
          path="fit-out-source/leader-in-the-industry/:type/main-detail/:id"
          element={<HospitalityPodcastDetail main_tye={true} />}
        />
        <Route
          path="fit-out-source/leader-in-the-industry/podcast-listing/:type"
          element={<PodcastWareHouseListing />}
        />{" "}
        <Route
          path="fit-out-source/leader-in-the-industry/:type/detail/:id"
          element={<HospitalityPodcastDetail />}
        />
        <Route
          path="hospitality/leader-in-the-industry/industry-news-listing"
          element={<IndustryNewshospitalityListing />}
        />
        <Route
          path="office-source/leader-in-industry/industry-news-listing"
          element={<OfficeIndustryList />}
        />
        <Route
          path="fit-out-source/leader-in-industry/industry-news-listing"
          element={<FitOutIndustryList />}
        />
        <Route
          path="construction-source/leader-in-industry/industry-news-listing"
          element={<ConstructionIndustryList />}
        />
        <Route
          path="food-source/leader-in-industry/industry-news-listing"
          element={<FodIndustryList />}
        />
        <Route
          path="retail-source/leader-in-industry/industry-news-listing"
          element={<RetailIndustryList />}
        />
        <Route
          path="healthcare/leader-in-industry/industry-news-listing"
          element={<IndustryListingHealthCare />}
        />
        <Route
          path="warehouse/leaders-in-the-industry/industry-news-listing"
          element={<IndustryNewsWareHouseListing />}
        />
        {/* =============hr section================== */}
        <Route path="hospitality/hr" element={<HR />} />
        <Route path="retail-source/hr" element={<HR />} />
        <Route path="fit-out-source/hr" element={<HR />} />
        <Route path="office-source/hr" element={<HR />} />
        <Route path="office-source/hr" element={<HR />} />
        <Route path="construction-source/hr" element={<HR />} />
        <Route path="food-source/hr" element={<HR />} />
        <Route path="food-source/hr/hr-blog/:id" element={<FitOutHrBlog />} />
        <Route path="office-source/hr/hr-blog/:id" element={<FitOutHrBlog />} />
        <Route
          path="fit-out-source/hr/hr-blog/:id"
          element={<FitOutHrBlog />}
        />
        <Route path="retail-source/hr/hr-blog/:id" element={<FitOutHrBlog />} />
        <Route path="hospitality/hr/hr-blog/:id" element={<FitOutHrBlog />} />
        <Route
          path="construction-source/hr/hr-blog/:id"
          element={<FitOutHrBlog />}
        />
        <Route path="warehouse/hr/hr-blog/:id" element={<FitOutHrBlog />} />
        <Route path="healthcare/hr/hr-blog/:id" element={<FitOutHrBlog />} />
        <Route path="warehouse/hr" element={<HR />} />
        <Route path="healthcare/hr" element={<HR />} />
        {/* =============hr detail outside================== */}
        <Route
          path="hospitality/hr/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path="hospitality/interview/blog-detail/:id"
          element={<InterviewBlogDetailPage />}
        />
        <Route
          path="hospitality/mindset-source/blog-detail/:id"
          element={<MindsetBlogDetailPage />}
        />
        <Route
          path="warehouse/mindset-source/blog-detail/:id"
          element={<MindsetBlogDetailPage />}
        />
        <Route
          path="healthcare/mindset-source/blog-detail/:id"
          element={<MindsetBlogDetailPage />}
        />
        <Route
          path="office-source/mindset-source/blog-detail/:id"
          element={<MindsetBlogDetailPage />}
        />
        <Route
          path="retail-source/mindset-source/blog-detail/:id"
          element={<MindsetBlogDetailPage />}
        />
        <Route
          path="food-source/mindset-source/blog-detail/:id"
          element={<MindsetBlogDetailPage />}
        />
        <Route
          path="construction/mindset-source/blog-detail/:id"
          element={<MindsetBlogDetailPage />}
        />
        <Route
          path="fit-out-source/mindset-source/blog-detail/:id"
          element={<MindsetBlogDetailPage />}
        />
        <Route
          path="warehouse/interview/blog-detail/:id"
          element={<InterviewBlogDetailPage />}
        />
        <Route
          path="healthcare/interview/blog-detail/:id"
          element={<InterviewBlogDetailPage />}
        />
        <Route
          path="office-source/interview/blog-detail/:id"
          element={<InterviewBlogDetailPage />}
        />
        <Route
          path="food-source/interview/blog-detail/:id"
          element={<InterviewBlogDetailPage />}
        />
        <Route
          path="retail-source/interview/blog-detail/:id"
          element={<InterviewBlogDetailPage />}
        />
        <Route
          path="construction-source/interview/blog-detail/:id"
          element={<InterviewBlogDetailPage />}
        />
        <Route
          path="fit-out-source/interview/blog-detail/:id"
          element={<InterviewBlogDetailPage />}
        />
        <Route
          path="construction-source/hr/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path="office-source/hr/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path="fit-out-source/hr/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path="food-source/hr/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path="retail-source/hr/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path="healthcare/hr/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route path="warehouse/hr/blog-detail/:id" element={<HrBlogDetail />} />
        {/* =============hr detail inside================== */}
        <Route
          path="hospitality/hr/hr-blog/:id/blog-detail/:blog_id"
          element={<HRblogDetailInside />}
        />
        <Route
          path="warehouse/hr/hr-blog/:id/blog-detail/:blog_id"
          element={<HRblogDetailInside />}
        />
        <Route
          path="healthcare/hr/hr-blog/:id/blog-detail/:blog_id"
          element={<HRblogDetailInside />}
        />
        <Route
          path="retail-source/hr/hr-blog/:id/blog-detail/:blog_id"
          element={<HRblogDetailInside />}
        />
        <Route
          path="office-source/hr/hr-blog/:id/blog-detail/:blog_id"
          element={<HRblogDetailInside />}
        />
        <Route
          path="construction-source/hr/hr-blog/:id/blog-detail/:blog_id"
          element={<HRblogDetailInside />}
        />
        <Route
          path="food-source/hr/hr-blog/:id/blog-detail/:blog_id"
          element={<HRblogDetailInside />}
        />
        <Route
          path="fit-out-source/hr/hr-blog/:id/blog-detail/:blog_id"
          element={<HRblogDetailInside />}
        />
        {/* =============hr section================== */}
        <Route
          path="hospitality/hr/blog-list"
          element={<WareHouseBloglist />}
        />
        <Route path="fit-out-source/hr/blog-list" element={<FitOutHrBlog />} />
        <Route
          path="construction-source/hr/blog-list"
          element={<ConstructionBlogList />}
        />
        <Route
          path="retail-source/hr/blog-list"
          element={<RetailSourceBlogHr />}
        />
        <Route
          path="office-source/hr/blog-list"
          element={<OfficeHrBlogList />}
        />
        {/* <Route path="/:category/favourite-jobs" element={<FavouriteJobs />} /> */}
        <Route path="/:category/job-detail/:id" element={<JobDetailPage />} />
        <Route path="food-source/hr/blog-list" element={<FoodSourceHrBlog />} />
        <Route path="healthcare/hr/blog-list" element={<FoodSourceHrBlog />} />
        <Route path="warehouse/hr/blog-list" element={<WareHouseBloglist />} />
        <Route
          path="construction-source/hr/blog-list/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path="fit-out-source/hr/blog-list/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path="hospitality/hr/blog-list/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path="food-source/hr/blog-list/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path="retail-source/hr/blog-list/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path="office-source/hr/blog-list/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path="healthcare/hr/blog-list/blog-detail/:id"
          element={<HrBlogDetail />}
        />
        <Route
          path=":category/hr/hr-blog/blog-detail/:id"
          element={<HRblogDetailInside />}
        />
        <Route
          path=":category/live-job-feed/job-detail-page/:id"
          element={<JobDetailPage />}
        />
        {/* Applied jobs */}
        <Route
          path="hospitality/live-job-feed/applied-jobs"
          element={<AppliedJobs />}
        />
        <Route
          path="warehouse/live-job-feed/applied-jobs"
          element={<AppliedJobs />}
        />
        <Route
          path="healthcare/live-job-feed/applied-jobs"
          element={<AppliedJobs />}
        />
        <Route
          path="retail-source/live-job-feed/applied-jobs"
          element={<AppliedJobs />}
        />
        <Route
          path="office-source/live-job-feed/applied-jobs"
          element={<AppliedJobs />}
        />
        <Route
          path="food-source/live-job-feed/applied-jobs"
          element={<AppliedJobs />}
        />
        <Route
          path="construction-source/live-job-feed/applied-jobs"
          element={<AppliedJobs />}
        />
        <Route
          path="fit-out-source/live-job-feed/applied-jobs"
          element={<AppliedJobs />}
        />
        {/* Applied jobs  end*/}
        {/* Applied jobs  outside */}
        <Route path="fit-out-source/applied-jobs" element={<AppliedJobs />} />
        <Route path="hospitality/applied-jobs" element={<AppliedJobs />} />
        <Route path="home/applied-jobs" element={<AppliedJobs />} />
        <Route path="warehouse/applied-jobs" element={<AppliedJobs />} />
        <Route path="office-source/applied-jobs" element={<AppliedJobs />} />
        <Route path="healthcare/applied-jobs" element={<AppliedJobs />} />
        <Route path="food-source/applied-jobs" element={<AppliedJobs />} />
        <Route
          path="construction-source/applied-jobs"
          element={<AppliedJobs />}
        />
        <Route path="retail-source/applied-jobs" element={<AppliedJobs />} />
        {/* Applied jobs outside  end*/}
        {/* ==========lve-job feed section */}
        <Route path="hospitality/live-job-feed" element={<LiveJobFeeed />} />
        <Route path="warehouse/live-job-feed" element={<LiveJobFeeed />} />
        <Route path="healthcare/live-job-feed" element={<LiveJobFeeed />} />
        <Route path="office-source/live-job-feed" element={<LiveJobFeeed />} />
        <Route path="retail-source/live-job-feed" element={<LiveJobFeeed />} />
        <Route path="food-source/live-job-feed" element={<LiveJobFeeed />} />
        <Route
          path="hospitality/live-job-feed/personal-jobs"
          element={<PersonalJobs />}
        />
        <Route
          path="warehouse/live-job-feed/personal-jobs"
          element={<PersonalJobs />}
        />
        <Route
          path="healthcare/live-job-feed/personal-jobs"
          element={<PersonalJobs />}
        />
        <Route
          path="office-source/live-job-feed/personal-jobs"
          element={<PersonalJobs />}
        />
        <Route
          path="retail-source/live-job-feed/personal-jobs"
          element={<PersonalJobs />}
        />
        <Route
          path="food-source/live-job-feed/personal-jobs"
          element={<PersonalJobs />}
        />
        <Route
          path="construction-source/live-job-feed/personal-jobs"
          element={<PersonalJobs />}
        />
        <Route
          path="fit-out-source/live-job-feed/personal-jobs"
          element={<PersonalJobs />}
        />
        <Route
          path="hospitality/live-job-feed/personal-jobs/job-detail/:id"
          element={<PersonalJobDetail />}
        />
        <Route
          path="warehouse/live-job-feed/personal-jobs/job-detail/:id"
          element={<PersonalJobDetail />}
        />
        <Route
          path="healthcare/live-job-feed/personal-jobs/job-detail/:id"
          element={<PersonalJobDetail />}
        />
        <Route
          path="office-source/live-job-feed/personal-jobs/job-detail/:id"
          element={<PersonalJobDetail />}
        />
        <Route
          path="food-source/live-job-feed/personal-jobs/job-detail/:id"
          element={<PersonalJobDetail />}
        />
        <Route
          path="retail-source/live-job-feed/personal-jobs/job-detail/:id"
          element={<PersonalJobDetail />}
        />
        <Route
          path="construction-source/live-job-feed/personal-jobs/job-detail/:id"
          element={<PersonalJobDetail />}
        />
        <Route
          path="fit-out-source/live-job-feed/personal-jobs/job-detail/:id"
          element={<PersonalJobDetail />}
        />
        <Route
          path="construction-source/live-job-feed"
          element={<LiveJobFeeed />}
        />
        <Route path="fit-out-source/live-job-feed" element={<LiveJobFeeed />} />
        {/* <Route
          path="warehouse/live-job-feed/job-detail-page/:id"
          element={<JobDetailPage />}
        /> */}
        {/*================================== Personal Page Candidates  page============================== */}
        <Route
          path="warehouse/live-job-feed/personal-jobs/job-candidates-page/:id"
          element={<PersonalPageCandidates />}
        />
        <Route
          path="hospitality/live-job-feed/personal-jobs/job-candidates-page/:id"
          element={<PersonalPageCandidates />}
        />
        <Route
          path="healthcare/live-job-feed/personal-jobs/job-candidates-page/:id"
          element={<PersonalPageCandidates />}
        />
        <Route
          path="office-source/live-job-feed/personal-jobs/job-candidates-page/:id"
          element={<PersonalPageCandidates />}
        />
        <Route
          path="retail-source/live-job-feed/personal-jobs/job-candidates-page/:id"
          element={<PersonalPageCandidates />}
        />
        <Route
          path="food-source/live-job-feed/personal-jobs/job-candidates-page/:id"
          element={<PersonalPageCandidates />}
        />
        <Route
          path="food-source/live-job-feed/personal-jobs/job-candidates-page/:id"
          element={<PersonalPageCandidates />}
        />
        <Route
          path="food-source/live-job-feed/personal-jobs/job-candidates-page/:id"
          element={<PersonalPageCandidates />}
        />
        <Route
          path="construction-source/live-job-feed/personal-jobs/job-candidates-page/:id"
          element={<PersonalPageCandidates />}
        />
        <Route
          path="fit-out-source/live-job-feed/personal-jobs/job-candidates-page/:id"
          element={<PersonalPageCandidates />}
        />
        {/*================================== candidates page============================== */}
        <Route
          path="warehouse/live-job-feed/job-candidates-page/:id"
          element={<Candidates />}
        />
        <Route
          path="hospitality/live-job-feed/job-candidates-page/:id"
          element={<Candidates />}
        />
        <Route
          path="healthcare/live-job-feed/job-candidates-page/:id"
          element={<Candidates />}
        />
        <Route
          path="office-source/live-job-feed/job-candidates-page/:id"
          element={<Candidates />}
        />
        <Route
          path="retail-source/live-job-feed/job-candidates-page/:id"
          element={<Candidates />}
        />
        <Route
          path="food-source/live-job-feed/job-candidates-page/:id"
          element={<Candidates />}
        />
        <Route
          path="construction-source/live-job-feed/job-candidates-page/:id"
          element={<Candidates />}
        />
        <Route
          path="fit-out-source/live-job-feed/job-candidates-page/:id"
          element={<Candidates />}
        />
        <Route
          path="healthcare/live-job-feed/job-candidates-page/:id"
          element={<Candidates />}
        />
        <Route
          path="/warehouse/live-job-feed/job-detail-page/:id"
          element={<JobDetailPage />}
        />
        <Route
          path="/healthcare/live-job-feed/job-detail-page/:id"
          element={<JobDetailPage />}
        />
        <Route
          path="/office-source/live-job-feed/job-detail-page/:id"
          element={<JobDetailPage />}
        />
        {/* ==========lve-job feed section */}
        <Route
          path="healthcare/live-job-feed/job-detail-page"
          element={<JobDetailPage />}
        />
        <Route
          path="construction-source/live-job-feed/job-detail-page"
          element={<JobDetailPage />}
        />
        <Route
          path="fit-out-source/live-job-feed/job-detail-page"
          element={<JobDetailPage />}
        />
        <Route
          path="food-source/live-job-feed/job-detail-page"
          element={<JobDetailPage />}
        />
        <Route
          path="retail-source/live-job-feed/job-detail-page"
          element={<JobDetailPage />}
        />
        <Route
          path="/:category/training-source/blog-list/blog-detail/:id"
          element={<TraingBlogDetail />}
        />
        <Route
          path="retail-source/live-job-feed/job-detail-page"
          element={<JobDetailPage />}
        />
        <Route
          path="office-source/live-job-feed/job-detail-page"
          element={<JobDetailPage />}
        />
        <Route
          path="hospitality/live-job-feed/job-detail-page/:id"
          element={<JobDetailPage />}
        />
        <Route path="home/feed-job-detail/:id" element={<PostJobDetail2 />} />
        <Route path="home/candidates/:id" element={<Candidates2 />} />
        <Route path="hospitality/candidates/:id" element={<Candidates2 />} />
        <Route path="warehouse/candidates/:id" element={<Candidates2 />} />
        <Route path="healthcare/candidates/:id" element={<Candidates2 />} />
        <Route path="office-source/candidates/:id" element={<Candidates2 />} />
        <Route path="retail-source/candidates/:id" element={<Candidates2 />} />
        <Route path="fit-out-source/candidates/:id" element={<Candidates2 />} />
        <Route path="food-source/candidates/:id" element={<Candidates2 />} />
        {/* payment Request */}
        <Route path="payment-requests" element={<PaymentRequests />} />
        <Route path="payment-requests/:id" element={<PendingRequestsPayment />} />
        <Route path="payment-request-details/:id" element={<PaymentRequestsDetails />} />
        <Route
          path="payment-requests/pending-request"
          element={<PendingRequests />}
        />
        <Route
          path="payment-requests/accepted-request"
          element={<PendingRequests />}
        />
        {/* payment Request */}
        <Route
          path="construction-source/candidates/:id"
          element={<Candidates2 />}
        />
        <Route
          path="fit-out-source/feed-job-detail/:id"
          element={<PostJobDetail2 />}
        />
        <Route
          path="construction-source/feed-job-detail/:id"
          element={<PostJobDetail2 />}
        />
        <Route
          path="food-source/feed-job-detail/:id"
          element={<PostJobDetail2 />}
        />
        <Route
          path="retail-source/feed-job-detail/:id"
          element={<PostJobDetail2 />}
        />
        <Route
          path="office-source/feed-job-detail/:id"
          element={<PostJobDetail2 />}
        />
        <Route
          path="healthcare/feed-job-detail/:id"
          element={<PostJobDetail2 />}
        />
        <Route
          path="warehouse/feed-job-detail/:id"
          element={<PostJobDetail2 />}
        />
        <Route
          path="hospitality/feed-job-detail/:id"
          element={<PostJobDetail2 />}
        />
        {/* ===================================JD Section start==================================== */}
        <Route
          path="hospitality/job-description"
          element={<JobDescription />}
        />
        <Route
          path="hospitality/job-description/blog-list/:id"
          element={<JDListall />}
        />
        <Route
          path="hospitality/job-description/blog-list/:blog_id/blog-detail/:id"
          element={<JDDetailAll />}
        />
        <Route path="warehouse/job-description" element={<JobDescription />} />
        <Route
          path="warehouse/job-description/blog-list/:id"
          element={<JDListall />}
        />
        <Route
          path="warehouse/job-description/blog-list/:blog_id/blog-detail/:id"
          element={<JDDetailAll />}
        />
        <Route path="healthcare/job-description" element={<JobDescription />} />
        <Route
          path="healthcare/job-description/blog-list/:id"
          element={<JDListall />}
        />
        <Route
          path="healthcare/job-description/blog-list/:blog_id/blog-detail/:id"
          element={<JDDetailAll />}
        />
        <Route
          path="office-source/job-description"
          element={<JobDescription />}
        />
        <Route
          path="office-source/job-description/blog-list/:id"
          element={<JDListall />}
        />
        <Route
          path="office-source/job-description/blog-list/:blog_id/blog-detail/:id"
          element={<JDDetailAll />}
        />
        <Route
          path="retail-source/job-description"
          element={<JobDescription />}
        />
        <Route
          path="retail-source/job-description/blog-list/:id"
          element={<JDListall />}
        />
        <Route
          path="retail-source/job-description/blog-list/:blog_id/blog-detail/:id"
          element={<JDDetailAll />}
        />
        <Route
          path="construction-source/job-description"
          element={<JobDescription />}
        />
        <Route
          path="construction-source/job-description/blog-list/:id"
          element={<JDListall />}
        />
        <Route
          path="construction-source/job-description/blog-list/:blog_id/blog-detail/:id"
          element={<JDDetailAll />}
        />
        <Route
          path="food-source/job-description"
          element={<JobDescription />}
        />
        <Route
          path="food-source/job-description/blog-list/:id"
          element={<JDListall />}
        />
        <Route
          path="food-source/job-description/blog-list/:blog_id/blog-detail/:id"
          element={<JDDetailAll />}
        />
        <Route
          path="fit-out-source/job-description"
          element={<JobDescription />}
        />
        <Route
          path="fit-out-source/job-description/blog-list/:id"
          element={<JDListall />}
        />
        <Route
          path="fit-out-source/job-description/blog-list/:blog_id/blog-detail/:id"
          element={<JDDetailAll />}
        />
        {/* ===================================JD Section end==================================== */}
        {/* ===================================temoing Section start==================================== */}
        <Route path="hospitality/temping" element={<Temping />} />
        <Route
          path="hospitality/temping/blog-list/:id"
          element={<TempingListall />}
        />
        <Route
          path="hospitality/temping/blog-list/:blog_id/blog-detail/:id"
          element={<TempingDetailall />}
        />
        <Route path="warehouse/temping" element={<Temping />} />
        <Route
          path="warehouse/temping/blog-list/:id"
          element={<TempingListall />}
        />
        <Route
          path="warehouse/temping/blog-list/:blog_id/blog-detail/:id"
          element={<TempingDetailall />}
        />
        <Route path="healthcare/temping" element={<Temping />} />
        <Route
          path="healthcare/temping/blog-list/:id"
          element={<TempingListall />}
        />
        <Route
          path="healthcare/temping/blog-list/:blog_id/blog-detail/:id"
          element={<TempingDetailall />}
        />
        <Route path="office-source/temping" element={<Temping />} />
        <Route
          path="office-source/temping/blog-list/:id"
          element={<TempingListall />}
        />
        <Route
          path="office-source/temping/blog-list/:blog_id/blog-detail/:id"
          element={<TempingDetailall />}
        />
        <Route path="retail-source/temping" element={<Temping />} />
        <Route
          path="retail-source/temping/blog-list/:id"
          element={<TempingListall />}
        />
        <Route
          path="retail-source/temping/blog-list/:blog_id/blog-detail/:id"
          element={<TempingDetailall />}
        />
        <Route path="food-source/temping" element={<Temping />} />
        <Route
          path="food-source/temping/blog-list/:id"
          element={<TempingListall />}
        />
        <Route
          path="food-source/temping/blog-list/:blog_id/blog-detail/:id"
          element={<TempingDetailall />}
        />
        <Route path="construction-source/temping" element={<Temping />} />
        <Route
          path="construction-source/temping/blog-list/:id"
          element={<TempingListall />}
        />
        <Route
          path="construction-source/temping/blog-list/:blog_id/blog-detail/:id"
          element={<TempingDetailall />}
        />
        <Route path="fit-out-source/temping" element={<Temping />} />
        <Route
          path="fit-out-source/temping/blog-list/:id"
          element={<TempingListall />}
        />
        <Route
          path="fit-out-source/temping/blog-list/:blog_id/blog-detail/:id"
          element={<TempingDetailall />}
        />
        {/* =================================== temping end==================================== */}
        <Route
          path="hospitality/partners/affilation-partners/affilation-detail/:id"
          element={<AffilationsDetail />}
        />
        <Route
          path="warehouse/partners/affilation-partners/affiliation-detail/:id"
          element={<WareHouseaffiliationDetail />}
        />
        {/* <Route path="/hospitality/interview" element={<InterviewPage />} />
        <Route path="/hospitality/leaders" element={<LeadersPage />} />
        <Route path="/hospitality/hr" element={<HRPage />} />
        <Route
          path="/hospitality/job-description"
          element={<JobDescriptionPage />}
        /> */}
      </Route>

      {/* Auth routes */}
      <Route element={<LogoOnlyLayout />}>
        <Route path="/" element={<Authentication />} />

        <Route path="login" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="register" element={<Registerform />} />
        <Route path="otp" element={<OtpScreen />} />
        <Route path="*" element={<Authentication />} />

        <Route path="confirm-password" element={<ConfirmPassword />} />
      </Route>
      <Route
        path="no-access"
        element={<RecordNotFound2 title="Page Not Found" />}
      />
    </Routes>
  );
}
